import { ArrowBackRounded } from "@mui/icons-material";
import {
  Divider,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import StatusWidget from "./StatusWidget";
import { formatDate, useFormatPrice } from "hooks";

const Details = ({ order }) => {
  const formatPrice = useFormatPrice();

  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };
  return (
    <>
      <Grid item xs={12}>
        <div className="flex flex-wrap items-center gap-2 justify-between">
          <div>
            <IconButton onClick={handleBack} className="border">
              <ArrowBackRounded />
            </IconButton>
          </div>
          <div className="flex gap-[10px] items-center text-gray-500">
            <span>
              Order Number:&nbsp;
              <span className="text-[24px] font-bold">{order.orderNo}</span>
            </span>
            <StatusWidget status={order.status} isOverdue={order.isOverdue} />
          </div>
        </div>

        <Divider className="pt-[10px]" />
      </Grid>

      <Grid item xs={12} md={6}>
        <TableContainer>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell className="!font-medium">Deliver to</TableCell>
                <TableCell>
                  : {order.recipientOutlet && order.recipientOutlet.outletName}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="!font-medium">Ordered For</TableCell>
                <TableCell>
                  :{" "}
                  {order.orderingFor &&
                    order.orderingFor.map((val, ind) => (
                      <span key={ind}>
                        {val.outlet && val.outlet.outletName}{" "}
                        {order.orderingFor.length > ind + 1 ? " | " : ""}
                      </span>
                    ))}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="!font-medium">Supplier</TableCell>
                <TableCell>
                  : {order.splr.company} ({order.splr.splrName})
                </TableCell>
              </TableRow>
              {order.note && (
                <TableRow>
                  <TableCell className="!font-medium">Note</TableCell>
                  <TableCell>: {order.note}</TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell className="!font-medium">Created by</TableCell>
                <TableCell>: {order?.user?.fullName}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="!font-medium">Created</TableCell>
                <TableCell>: {formatDate(order.createDate)}</TableCell>
              </TableRow>

              {order.updateDate && (
                <TableRow>
                  <TableCell className="!font-medium">Updated</TableCell>
                  <TableCell>: {formatDate(order.updateDate)}</TableCell>
                </TableRow>
              )}

              <TableRow>
                <TableCell className="!font-medium">Delivery Date: </TableCell>
                <TableCell>: {formatDate(order.deliveryDate)}</TableCell>
              </TableRow>

              {order.receiveDate && (
                <TableRow>
                  <TableCell className="!font-medium"> Received</TableCell>
                  <TableCell>: {formatDate(order.receiveDate)}</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

      <Grid item xs={12} md={6}>
        <TableContainer>
          <Table size="small">
            <TableBody>
              {order.status === 3 && (
                <>
                  <TableRow>
                    <TableCell className="!font-medium">Cancel Date</TableCell>
                    <TableCell>: {formatDate(order.cancelDate)}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="!font-medium">Cancel User</TableCell>
                    <TableCell>
                      : {order.cancelUser && order.cancelUser?.fullName}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="!font-medium">
                      Cancel Reason
                    </TableCell>
                    <TableCell>
                      <span
                        className="font-normal text-gray-500 whitespace-pre-wrap"
                        style={{ lineHeight: "1.4rem" }}
                      >
                        : {order.cancelReason}
                      </span>
                    </TableCell>
                  </TableRow>
                </>
              )}

              <TableRow>
                <TableCell className="!font-medium">
                  <span className="flex !w-max">Subtotal of Products</span>
                </TableCell>
                <TableCell>: {formatPrice(order.subtotal)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="!font-medium">
                  Discount {order.discountType === 1 && ` (${order.discount}%)`}
                </TableCell>
                <TableCell>: (-) {formatPrice(order.disAmt)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="!font-medium">Shipping</TableCell>
                <TableCell>: {formatPrice(order.shippingFee)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="!font-medium">Import duty</TableCell>
                <TableCell>: {formatPrice(order.importDuty)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="!font-medium !text-[18px]">
                  Order Total
                </TableCell>
                <TableCell className="!text-gray-500 !font-medium !text-[18px]">
                  : {formatPrice(order.totalOrderAmt)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

      <Grid item xs={12}></Grid>
    </>
  );
};

export default Details;
